import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { WmsOrderDetailDto, WmsOrderHeaderDto } from "src/dtos/wmsOrder/wmsOrderDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS1031_R01Dto {
	wmsOrderHeaderDto: WMS1031_R01HeaderDto;
	wmsOrderDetailDtoList: WMS1031_R01DetailDto[];
}

export interface WMS1031_R01HeaderDto extends WmsOrderHeaderDto {
	
	salesOrderNo: string;	// 수주번호
	dueDt: string;	// 수주의 납기일자

}

export const defaultWMS1031_R01HeaderDto: WMS1031_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	wmsOrderNo: '',
	compCd: '',
	compNm: '',	
	logicCenter: '',
	orderDt: formatDate(new Date()),
	inoutType: '',
	inoutClass: '230', // 출고구분값 230으로 고정(영업출고)
	customCd: '',
	customNm: '',
	deadlineDt: formatDate(new Date()),
	inoutMethod: '',
	empNo: '',
	empNm: '',
	orderAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	inoutStatus: '',
	approveFlg: '',
	closeTag: 'N',
	remark: '',

	warehouseCd: '',
	salesOrderNo: '',
	dueDt: formatDate(new Date()),

	inserted: false,
	isModified: false
}

// 구매실적 상세 DTO (단일 상속 방식)
export interface WMS1031_R01DetailDto extends WmsOrderDetailDto {
	//재고테이블에 등록된 가용재고
	stockQty: number;
	// availableQty: number;
	// 이번 출고량(직접 입력)
	updateTransportQty: number; 
	orderQtyView: number; // 주문잔량 : 주문량 - 기출고량 조회용
}


export const defaultWMS1031_R01DetailDto: WMS1031_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	wmsOrderNo: '',
	itemNo: '',
	itemNm: '',
	itemSpec: '',
	modelNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	orderDt: formatDate(new Date()),
	itemSeq: 0,
	itemCd: '',
	itemStatus: '',
	orderUnit: '',
	orderQty: 0,
	cancelQty: 0,
	dcAmt: 0,
	orderPrice: 0,
	orderAmt: 0,
	transportQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	stockQty: 0,
	updateTransportQty: 0,
	orderQtyView: 0, // 주문잔량 : 주문량 - 기출고량 조회용
	
	inserted: false,
	isModified: false
}

export interface WMS1031_R01LotDto extends WmsStockLotDto {
	inputOutQty: number;
}

export const defaultWMS1031_R01LotDto: WMS1031_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	inputOutQty: 0,

	inserted: false,
	isModified: false,
}
